<template>
  <span class="copy">
    <span class="ellipsis" style="display: inline-block" :style="{ maxWidth: width }" :title="text" @click="$emit('click')" v-text="text" />
    <i class="pointer iconfont icon-fuzhi" @click="copy(text)" />
  </span>
</template>

<script>
import { copy } from '@/utils/copy'
export default {
  name: 'Copy',
  props: {
    text: {
      type: String,
      require: true,
      default: ''
    },
    width: {
      type: String,
      default: '200px'
    }
  },
  methods: {
    copy
  }
}
</script>

<style lang="scss" scoped>
.icon-fuzhi{
  margin-left: 2px;
  visibility: hidden;
}
.copy:hover > .icon-fuzhi{
  visibility: visible;
}
.copy {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}
</style>
